/* Publish by EComposer at 2025-08-01 19:29:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-guhjdyse7d9"]=  window.__ectimmers["ecom-guhjdyse7d9"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(t&&t.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",t.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-guhjdyse7d9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-guhjdyse7d9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uo7b4pkop69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uo7b4pkop69', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfbqeb0wsm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfbqeb0wsm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87thooyogix').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87thooyogix', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xg9vau3zijl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xg9vau3zijl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-26t22cgvmcj"]=  window.__ectimmers["ecom-26t22cgvmcj"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(i){if(!e)return;const o=e.querySelector(".ecom__element--button");if(!o)return;let s=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-26t22cgvmcj"]["othruzqxk"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},n)},s)}(this);var t=e.querySelector(".ecom__element--button");this.isLive&&t&&t.dataset.ecTrackingId&&t.addEventListener("click",function(i){if(window.Shopify.analytics){i.preventDefault();let o=document.createElement("div");document.body.appendChild(o),o.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};Shopify.analytics.publish("ec_custom_events",J({button_id:t.id,tracking_id:t.dataset.ecTrackingId},s)),t.cloneNode(!0).click()}},{once:!0}),this.isLive&&t&&t.dataset.eventTrackingFb&&t.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${t.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-26t22cgvmcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-26t22cgvmcj', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cll2h9378fu"]=  window.__ectimmers["ecom-cll2h9378fu"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let t=this.$el;if(!t)return;function i(s){const n=s.getBoundingClientRect();return n.top>=0&&n.left>=0&&n.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&n.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let s=t.querySelector(".ecom-element.ecom-base-image"),n=t.closest(".core__row--columns");s&&(i(s)?(s.classList.add("image-highlight"),n.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),n.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-cll2h9378fu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cll2h9378fu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k0ix683vth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0ix683vth', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hm1653v28f9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hm1653v28f9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l65kh11n9fp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l65kh11n9fp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}